var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { isValidElement } from "react";
import { fromActionIdToUniqueId, TableKebabActionMenu, } from "./KebabWithPortal";
import ButtonIcon from "../button-icon/ButtonIcon";
import { isTableActionItemProps } from "./TableActionItem";
import { trapEvent } from "../../utils/EventHelpers";
import { StyledTableActionColumnContainer, StyledTableActionButtonsContainer } from "./TableActionColumn.style";
import { StyledHiddenScreenReaderOnly } from "../../utils/StyleUtils";
import { TABLE_NAMESPACE as ns } from "./utils";
import translationEN from "./locales/translation-en.json";
import translationFR from "./locales/translation-fr.json";
export const prefixId = "nx-action-column-";
export const isTableActionColumnRenderer = (childrenOrRenderer) => typeof childrenOrRenderer === "function" && !Array.isArray(childrenOrRenderer) && !isValidElement(childrenOrRenderer);
export const isTableActionType = (type) => type === TableActionColumn.displayName;
export const actionsHeaderCellRenderer = (t, nxI18n) => {
    nxI18n.addResources("en", ns, translationEN);
    nxI18n.addResources("fr", ns, translationFR);
    const renderer = () => React.createElement(StyledHiddenScreenReaderOnly, null, t("actionsHeader", { ns }));
    renderer.displayName = "actionsHeaderCellRenderer";
    return renderer;
};
export const actionsCellRenderer = (kebabId, actions, kebab = false, insightsAttr, actionMenuMaxHeight, actionMenuHandleQuickFind, hasActions) => 
// eslint-disable-next-line react/display-name
(params) => {
    const _a = params.dataItem, { _config: _ } = _a, originalDataItem = __rest(_a, ["_config"]);
    const actionParams = Object.assign(Object.assign({}, params), { dataItem: originalDataItem });
    const showActions = hasActions ? hasActions(actionParams) : true;
    return (React.createElement(StyledTableActionColumnContainer, null, !!actions && showActions && (React.createElement(React.Fragment, null, kebab ? (React.createElement(TableKebabActionMenu, { "data-insights": insightsAttr && `kebab-${fromActionIdToUniqueId(insightsAttr, kebabId)}`, id: `kebab-${kebabId}`, actions: actions, params: actionParams, maxHeight: actionMenuMaxHeight, handleQuickFind: actionMenuHandleQuickFind, "aria-label": `Actions for row ${params.dataIndex}` })) : (React.createElement(StyledTableActionButtonsContainer, null, Array.isArray(actions) &&
        actions.map((props) => {
            if (isTableActionItemProps(props)) {
                const { id, "data-insights": actionItemInsightsAttr, onClick, label } = props, rest = __rest(props, ["id", "data-insights", "onClick", "label"]);
                const insights = actionItemInsightsAttr || insightsAttr;
                const actionInsightsAttr = insights && fromActionIdToUniqueId(insights, id);
                return (React.createElement(ButtonIcon, Object.assign({ key: `${params.id}-${id}` }, rest, { "aria-label": label, id: `${params.id}-${id}`, "data-insights": actionInsightsAttr, variant: "round" }, (onClick && {
                    onClick: (e) => {
                        trapEvent(e);
                        onClick(actionParams);
                    },
                }))));
            }
            return null;
        })))))));
};
const TableActionColumn = () => {
    return React.createElement(React.Fragment, null);
};
export const isTableActionColumnType = (type) => type === "TableActionColumn";
export default TableActionColumn;
//# sourceMappingURL=TableActionColumn.js.map